import project_thumbnail_01 from '../assets/images/work/norcat-lock-tag/thumbnail.png';
import project_thumbnail_13 from '../assets/images/work/industrial-hazard-recognition/IndustrialHazardRecognition_thumbnail.jpg';
import project_thumbnail_14 from '../assets/images/work/agnico-eagle-experience/AgnicoEagleExperience_thumbnail.jpg';
import project_thumbnail_02 from '../assets/images/work/vale-hrp/Vale HRP_thumbnail.jpg';
import project_thumbnail_03 from '../assets/images/work/fiar/FiAR_thumbnail.jpg';
import project_thumbnail_04 from '../assets/images/work/opg-sim/OPG_thumbnail.jpg';
import project_thumbnail_05 from '../assets/images/work/sn-nex/thumbnail.jpg';
import project_thumbnail_06 from '../assets/images/work/vale-preop/Vale Pre-Op_thumbnail.jpg';
import project_thumbnail_07 from '../assets/images/work/certifire/Certifire_thumbnail.jpg';
import project_thumbnail_08 from '../assets/images/work/motor-control/Motor Control_thumbnail.jpg';
import project_thumbnail_09 from '../assets/images/work/hoisting-rigging/H&R_thumbnail.jpg';
import project_thumbnail_10 from '../assets/images/work/sn-cas/CAS_thumbnail.jpg';
import project_thumbnail_11 from '../assets/images/work/ontario-mine-rescue/OMR_thumbnail.jpg';
import project_thumbnail_12 from '../assets/images/work/nxr/NXR_thumbnail.jpg';

export const projectData = [
    {
        heading: 'Experiential Training',
        description: 'Lock & Tag Program',
        name: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed felis ante, accumsan laoreet cursus faucibus, consectetur eget risus.',
        namespan: 'NORCAT, 2026',
        image: project_thumbnail_01,
        alt: 'norcat-lock-tag-project-thumbnail',
        slug: 'norcat-lock-tag',
    },
    {
        heading: 'Experiential Training',
        description: 'Vale HRP',
        name: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed felis ante, accumsan laoreet cursus faucibus, consectetur eget risus.',
        namespan: 'Vale North Atlantic, 2025',
        image: project_thumbnail_02,
        alt: 'vale-hrp-project-thumbnail',
        slug: 'vale-hrp',
    },
    {
        heading: 'Experiential Training',
        description: 'FiAR',
        name: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed felis ante, accumsan laoreet cursus faucibus, consectetur eget risus.',
        namespan: 'NORCAT, 2020-Present',
        image: project_thumbnail_03,
        alt: 'fiar-project-thumbnail',
        slug: 'fiar',
    },
    {
        heading: 'Simulation Tool',
        description: 'OPG Incident Command',
        name: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed felis ante, accumsan laoreet cursus faucibus, consectetur eget risus.',
        namespan: 'Ontario Power Generation, 2025-Present',
        image: project_thumbnail_04,
        alt: 'ontario-power-generation-project-thumbnail',
        slug: 'opg-sim',
    },
    {
        heading: 'Product & Platform',
        description: 'Nature Exchange',
        name: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed felis ante, accumsan laoreet cursus faucibus, consectetur eget risus.',
        namespan: 'Science North, 2025-2026',
        image: project_thumbnail_05,
        alt: 'nature-exchange-project-thumbnail',
        slug: 'sn-nex',
    },
    {
        heading: 'Experiential Training',
        description: 'Vale Pre-Op',
        name: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed felis ante, accumsan laoreet cursus faucibus, consectetur eget risus.',
        namespan: 'Vale North Atlantic, 2021',
        image: project_thumbnail_06,
        alt: 'vale-preop-project-thumbnail',
        slug: 'vale-preop',
    },
    {
        heading: 'Experiential Training',
        description: 'CertiFire',
        name: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed felis ante, accumsan laoreet cursus faucibus, consectetur eget risus.',
        namespan: 'ECAO, CertiFire, 2023-Present',
        image: project_thumbnail_07,
        alt: 'certifire-project-thumbnail',
        slug: 'certifire',
    },
    {
        heading: 'Experiential Training',
        description: 'Motor Control',
        name: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed felis ante, accumsan laoreet cursus faucibus, consectetur eget risus.',
        namespan: 'NETCO, 2024',
        image: project_thumbnail_08,
        alt: 'motor-control-project-thumbnail',
        slug: 'motor-control',
    },
    {
        heading: 'Experiential Training',
        description: 'Hoisting & Rigging',
        name: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed felis ante, accumsan laoreet cursus faucibus, consectetur eget risus.',
        namespan: 'NETCO, 2023',
        image: project_thumbnail_09,
        alt: 'hoisting-rigging-project-thumbnail',
        slug: 'hoisting-rigging',
    },
    {
        heading: 'Interactive Installation',
        description: 'Climate Action Show',
        name: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed felis ante, accumsan laoreet cursus faucibus, consectetur eget risus.',
        namespan: 'Science North, 2023',
        image: project_thumbnail_10,
        alt: 'climate-action-show-project-thumbnail',
        slug: 'sn-cas',
    },
    {
        heading: 'Interactive Installation',
        description: 'Ontario Mine Rescue',
        name: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed felis ante, accumsan laoreet cursus faucibus, consectetur eget risus.',
        namespan: 'Science North, Ontario Mine Rescue, 2019',
        image: project_thumbnail_11,
        alt: 'ontario-mine-rescue-project-thumbnail',
        slug: 'ontario-mine-rescue',
    },
    {
        heading: 'Experiential Training',
        description: 'Agnico Eagle Experience',
        name: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed felis ante, accumsan laoreet cursus faucibus, consectetur eget risus.',
        namespan: 'Agnico Eagle, 2026',
        image: project_thumbnail_14,
        alt: 'agnico-eagle-experience-project-thumbnail',
        slug: 'agnico-eagle-experience',
    },
    {
        heading: 'Experiential Training',
        description: 'Industrial Hazard Recognition Program',
        name: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed felis ante, accumsan laoreet cursus faucibus, consectetur eget risus.',
        namespan: 'NORCAT (Internal), 2026',
        image: project_thumbnail_13,
        alt: 'industrial-hazard-recognition-program-project-thumbnail',
        slug: 'industrial-hazard-recognition-program',
    },
    {
        heading: 'Platform',
        description: 'NXR',
        name: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed felis ante, accumsan laoreet cursus faucibus, consectetur eget risus.',
        namespan: 'NORCAT, 2017-Present',
        image: project_thumbnail_12,
        alt: 'nxr-project-thumbnail',
        slug: 'norcat-nxr',
    },
];
